import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import CybeatsConfigListing from "./CybeatsConfigListing";
import CybeatsCredentialsForm from "./CybeatsCredentialsForm";

export default function CybeatsPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={CybeatsCredentialsForm}
      PullConfigListingView={CybeatsConfigListing}
    />
  );
}